import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import HomePage from './landing_page/home/HomePage';
import { BrowserRouter,Routes,Route } from "react-router-dom"
import Signup from'./landing_page/signup/Signup'

import SupportPage from'./landing_page/support/SupportPage'
import PricingPage from'./landing_page/pricing/PricingPage'
import Navbar from './landing_page/Navbar';
import Footer from './landing_page/Footer';
import NotFound from './landing_page/NotFound';
import ProductPage from "./landing_page/products/ProductPage";
import AboutPage from './landing_page/about/AboutPage';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
     <Navbar/>
    <Routes>
      <Route path='/' element={<HomePage/>}/>
      <Route path='signup' element={<Signup/>}/>
      <Route path='about' element={<AboutPage/>}/>
      <Route path='products' element={<ProductPage/>}/>
      <Route path='support' element={<SupportPage/>}/>
      <Route path='pricing' element={<PricingPage/>}/>
      <Route path='*' element={<NotFound/>}/>
    </Routes>
     <Footer/>
  </BrowserRouter>
);


